import { environment } from '../../environments/environment';

let cachedOrigins: Set<string> | null = null;

export function getAllowedApiOrigins(): Set<string> {
  if (!cachedOrigins) {
    cachedOrigins = new Set(
      [environment.domain, environment.base_url]
        .map((url) => {
          try {
            return new URL(url).origin;
          } catch {
            return null;
          }
        })
        .filter((origin): origin is string => !!origin)
    );
  }
  return cachedOrigins;
}

/** Relative URLs and configured API origins only. */
export function isTrustedApiRequest(url: string): boolean {
  if (!/^https?:\/\//i.test(url)) {
    return true;
  }

  try {
    return getAllowedApiOrigins().has(new URL(url).origin);
  } catch {
    return false;
  }
}
